import { AttributeProps, FetchAttributeProps, IAttribute, TAttributesState } from '../../types'
import { attributesAdapter } from './adapter'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { FetchCollectionParams, FetchCreatedAtParams, httpService, UpdateEntityProps } from '../../../services/_common'
import { parseHttpError } from '../../utils'
import { parseAttributes } from './utils'
import { TApiAttribute } from '../../../services/product/types'
import { selectors } from './selectors'
import { productService } from '../../../services'


const name = 'attributes'

const initialState: TAttributesState = {
    ...attributesAdapter.getInitialState(),
    isFetching: false,
    totalItems: 0,
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async (params: FetchCreatedAtParams & FetchCollectionParams | undefined) => {
        return httpService.fetchCollection<TApiAttribute, IAttribute, FetchAttributeProps>({
            url: '/attributes',
            params,
            parseFunction: parseAttributes
        })
    },
    {
        serializeError: parseHttpError
    }
)

const create = createAsyncThunk(
    `${name}/create`,
    async (attribute: AttributeProps) => {
        return await productService.createAttribute(attribute)
    },
    {
        serializeError: parseHttpError
    }
)

const update = createAsyncThunk(
    `${name}/create`,
    async (attribute: UpdateEntityProps<AttributeProps>) => {
        return await productService.updateAttribute(attribute)
    },
    {
        serializeError: parseHttpError
    }
)

const remove = createAsyncThunk(
    `${name}/remove`,
    async (id: string) => {
        return await productService.removeAttribute(id)
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                state.totalItems = action.payload.totalItems
                attributesAdapter.setAll(state, action.payload.entities)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const attributes = {
    name: slice.name,
    actions: {
        fetch,
        create,
        update,
        remove,
    },
    reducer: slice.reducer,
    selectors,
}